import { CreateFundsTransactionRequestDTO, FundsTransactionResponseDTO } from 'typings/dto/fundsTransaction';
import ModelActionsService from '../ModelActionsService';
import IFundsTransactionActionsService from './IFundsTransactionActionsService';

export default class FundsTransactionActionsServiceImpl
  extends ModelActionsService<FundsTransaction, CreateFundsTransactionRequestDTO, FundsTransactionResponseDTO>
  implements IFundsTransactionActionsService {}
